/**
 * Single-responsibility formatter for the Product list's "Climate Change
 * Impact" cell.
 *
 * Mirrors the two inline branches the legacy `ProductList` renders (see
 * src/screens/product/productList/ProductList.tsx) exactly — same copy for
 * an average product's aggregated value, and same three-way branch (upgrade
 * message for supplier users / stripped `kgCO2eq` value / in-progress copy)
 * for a single sales unit — just isolated so each can be reused/tested
 * without dragging the whole grid component along.
 */
export class ProductClimateImpactFormatter {
  static formatAverage(averageClimateImpact: number | undefined | null): string {
    return averageClimateImpact ? averageClimateImpact.toFixed(2) : "Calculation is in progress";
  }

  static formatSalesUnit(
    climateImpact: string | undefined | null,
    isUserSupplier: boolean
  ): string {
    if (!climateImpact) {
      return "Data collection in progress";
    }
    if (isUserSupplier) {
      return "Calculated: Upgrade to see results";
    }
    return climateImpact.toString().replace(/\s*kgCO2eq\s*$/, "");
  }
}
